import React, { useState, useContext } from 'react';
import { Outlet, useNavigate, useMatches } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import SideMenu from './SideMenu';

const drawerWidth = 250;

const DashboardLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // État pour le menu utilisateur
  const { logout, currentUser } = useContext(AuthContext); // Récupère logout et currentUser du contexte
  const navigate = useNavigate(); // Pour la redirection après déconnexion
  const matches = useMatches();

  // Trouve la route la plus spécifique qui a un 'handle' avec un 'title'
  const routeHandle = matches.findLast((match) => match.handle?.title);
  const title = routeHandle?.handle.title || 'Dashboard';

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout(); // Appelle la fonction de déconnexion du contexte
    navigate('/login'); // Redirige vers la page de connexion
    handleClose(); // Ferme le menu
  };

  const handleAccount = () => {
    // Logique pour naviguer vers la page "Mon Compte" (si elle existe)
    // Par exemple: navigate('/profile');
    handleClose();
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        aria-label="mailbox folders"
      >
        {/* Tiroir pour mobile */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{ display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth } }}
        >
          <SideMenu />
        </Drawer>
        {/* Tiroir permanent pour desktop */}
        <Drawer variant="permanent" sx={{ display: { xs: 'none', md: 'block' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth } }} open>
          <SideMenu />
        </Drawer>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, p: { md: 3 }, pt: 3, pb: 3, width: { md: `calc(100% - ${drawerWidth}px)` } }}>
        <Toolbar /> {/* Espace nécessaire pour que le contenu ne soit pas caché par l'AppBar */}
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;